/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { FaInfoCircle, FaUndo } from 'react-icons/fa';
import { connect } from 'react-redux';
import { TranslateWorkaround, COLORS } from '../../assets/constants/strings';
import { Search } from '../../store/Document/documentActions';
import CloseButton from '../Buttons/CloseButton';
import $ from 'jquery';

import './style.scoped.scss';
import TabIndexBtn from '../Buttons/TabIndex';

const AdvancedSearch = ({
  initialKeyword,
  documents,
  spStructure,
  handleClose,
  Search,
}) => {
  // today date formatted for inputs ('yyyy-MM-dd')

  const minYear = documents
    .filter((doc) => doc.versionDate !== null)
    .sort((doc1, doc2) => (doc1.versionDate > doc2.versionDate ? 1 : -1))[0]
    .versionDate.getFullYear()
    .toString();

  const minDate = new Date(`${minYear}-01-01`);
  const today = new Date();

  const [shouldSearchOnClose, setShouldSearchOnClose] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState(initialKeyword);

  const [selectedDoc, setSelectedDoc] = useState('-All-');
  const [selectedLevelOne, setSelectedLevelOne] = useState('-All-');
  const [selectedLevelTwo, setSelectedLevelTwo] = useState('-All-');
  const [selectedLevelThree, setSelectedLevelThree] = useState('-All-');
  const [selectedLevelFour, setSelectedLevelFour] = useState('-All-');

  const [selectedStartDate, setSelectedStartDate] = useState(minDate);
  const [selectedEndDate, setSelectedEndDate] = useState(today);

  const [substringSearch, setSubstringSearch] = useState(false);

  useEffect(() => {
    const startDateInput = document.getElementById('FromDate');
    const endDateInput = document.getElementById('ToDate');

    // max dates need to be today
    startDateInput.setAttribute('max', today.toISOString().substr(0, 10));
    endDateInput.setAttribute('max', today.toISOString().substr(0, 10));

    // min dates need to be 2020 or user defined value for later
    startDateInput.setAttribute('min', `${minYear}-01-01`);
    endDateInput.setAttribute('min', `${minYear}-01-01`);
  }, []);

  useEffect(() => {
    setSearchKeyword(initialKeyword);
  }, [initialKeyword]);

  const handleAdvSearch = () => {
    const filters = [
      { key: 'documentId', value: selectedDoc, type: 'equal' },
      { key: 'levelOne', value: selectedLevelOne, type: 'equal' },
      { key: 'levelTwo', value: selectedLevelTwo, type: 'equal' },
      { key: 'levelThree', value: selectedLevelThree, type: 'equal' },
      { key: 'levelFour', value: selectedLevelFour, type: 'equal' },
      { key: 'versionDate', value: selectedStartDate, type: 'larger' },
      { key: 'versionDate', value: selectedEndDate, type: 'smaller' },
    ];

    if (!shouldSearchOnClose) setShouldSearchOnClose(true);

    Search(searchKeyword, true, filters, substringSearch);
  };

  const handleClearFilters = (shouldSearch = true) => {
    // (have to clear both React and UI)
    setSelectedDoc('-All-');
    $('#docs-list').val('-All-');

    setSelectedLevelOne('-All-');
    $('#lvl1-list').val('-All-');

    setSelectedLevelTwo('-All-');
    $('#lvl2-list').val('-All-');

    setSelectedLevelThree('-All-');
    $('#lvl3-list').val('-All-');

    setSelectedLevelFour('-All-');
    $('#lvl4-list').val('-All-');
    if (shouldSearch) Search(searchKeyword);
  };

  // clear filters and hide component
  const handleCloseAdvSearch = () => {
    handleClearFilters(false);
    if (shouldSearchOnClose) Search(initialKeyword);
    handleClose();
  };

  //#region DDLists management

  const handleDocSelected = (documentID) => {
    setSelectedDoc(documentID);
  };

  const handleSelectedLevelOne = (LevelOneTitle) => {
    setSelectedLevelOne(LevelOneTitle);
  };

  const handleSelectedLevelTwo = (lvl2Title) => {
    setSelectedLevelTwo(lvl2Title);
  };

  const handleSelectedLevelThree = (lvl3Title) => {
    setSelectedLevelThree(lvl3Title);
  };

  const handleSelectedLevelFour = (lvl4Title) => {
    setSelectedLevelFour(lvl4Title);
  };

  const getAvailableDocs = () => {
    // not using Document as datatype since we need to have 'All' as the first item
    // const DocTitles = [{ title: '-All-', id: '-All-' }];
    const DocTitles = [];

    let filteredDocs = documents;

    if (selectedLevelOne !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelOne.Title === selectedLevelOne
      );

    if (selectedLevelTwo !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelTwo.Title === selectedLevelTwo
      );

    if (selectedLevelThree !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelThree && doc.levelThree.Title === selectedLevelThree
      );

    if (selectedLevelFour !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelFour && doc.levelFour.Title === selectedLevelFour
      );

    filteredDocs.forEach((doc) =>
      DocTitles.push({ title: doc.title, id: doc.id })
    );

    return [
      { title: '-All-', id: '-All-' },
      ...DocTitles.sort((a, b) =>
        a.title.localeCompare(b.title, undefined, { numeric: true })
      ),
    ];
  };

  const getAvailableLevelOnes = () => {
    const allLevelOnes = ['-All-']; // empty arr

    let filteredDocs = documents;

    if (selectedDoc !== '-All-')
      filteredDocs = filteredDocs.filter((doc) => doc.id === selectedDoc);

    if (selectedLevelTwo !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelTwo.Title === selectedLevelTwo
      );

    if (selectedLevelThree !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelThree && doc.levelThree.Title === selectedLevelThree
      );

    if (selectedLevelFour !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelFour && doc.levelFour.Title === selectedLevelFour
      );

    filteredDocs.forEach((doc) => {
      if (doc.levelOne) allLevelOnes.push(doc.levelOne.Title);
    }); // populate with LevelOnes

    return allLevelOnes
      .filter((value, index) => allLevelOnes.indexOf(value) === index) // remove duplicates
      .sort((a, b) => (a > b ? 1 : -1));
  };

  const getAvailableLevelTwos = () => {
    const allLevelTwos = ['-All-']; // empty arr

    let filteredDocs = documents;

    if (selectedDoc !== '-All-')
      filteredDocs = filteredDocs.filter((doc) => doc.id === selectedDoc);
    // else filteredDocs = documents;

    if (selectedLevelOne !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelOne.Title === selectedLevelOne
      );
    // else filteredDocs = documents;

    if (selectedLevelThree !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelThree && doc.levelThree.Title === selectedLevelThree
      );

    if (selectedLevelFour !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelFour && doc.levelFour.Title === selectedLevelFour
      );

    filteredDocs.forEach((doc) => {
      if (doc.levelTwo) allLevelTwos.push(doc.levelTwo.Title);
    }); // populate with levelTwo

    return allLevelTwos
      .filter((value, index) => allLevelTwos.indexOf(value) === index) // remove duplicates
      .sort((a, b) => (a > b ? 1 : -1));
  };

  const getAvailableLevelThrees = () => {
    const allLevelThrees = ['-All-']; // empty arr

    let filteredDocs = documents;

    if (selectedDoc !== '-All-')
      filteredDocs = filteredDocs.filter((doc) => doc.id === selectedDoc);
    // else filteredDocs = documents;

    if (selectedLevelOne !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelOne.Title === selectedLevelOne
      );
    // else filteredDocs = documents;

    if (selectedLevelTwo !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelTwo.Title === selectedLevelTwo
      );

    if (selectedLevelFour !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelFour && doc.levelFour.Title === selectedLevelFour
      );

    filteredDocs.forEach((doc) => {
      if (doc.levelThree) allLevelThrees.push(doc.levelThree.Title);
    }); // populate with levelThree

    return allLevelThrees
      .filter((value, index) => allLevelThrees.indexOf(value) === index) // remove duplicates
      .sort((a, b) => (a > b ? 1 : -1));
  };

  const getAvailableLevelFours = () => {
    const allLevelFours = ['-All-']; // empty arr

    let filteredDocs = documents;

    if (selectedDoc !== '-All-')
      filteredDocs = filteredDocs.filter((doc) => doc.id === selectedDoc);
    // else filteredDocs = documents;

    if (selectedLevelOne !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelOne.Title === selectedLevelOne
      );
    // else filteredDocs = documents;

    if (selectedLevelTwo !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelTwo.Title === selectedLevelTwo
      );

    if (selectedLevelThree !== '-All-')
      filteredDocs = filteredDocs.filter(
        (doc) => doc.levelThree && doc.levelThree.Title === selectedLevelThree
      );

    filteredDocs.forEach((doc) => {
      if (doc.levelFour) allLevelFours.push(doc.levelFour.Title);
    }); // populate with levelFour

    return allLevelFours
      .filter((value, index) => allLevelFours.indexOf(value) === index) // remove duplicates
      .sort((a, b) => (a > b ? 1 : -1));
  };

  const availableDocs = getAvailableDocs();

  const LevelOnesList = getAvailableLevelOnes();

  const LevelTwosList = getAvailableLevelTwos();

  const LevelThreesList = getAvailableLevelThrees();

  const LevelFoursList = getAvailableLevelFours();

  //#endregion

  const handleInput = (e) => {
    // any should be => React.ChangeEvent<HTMLInputElement>
    setSearchKeyword(e.target.value);
    if (e.keyCode === 13 || e.which === 13) {
      e.preventDefault();
      handleAdvSearch();
    }
  };

  const handleStartDateInput = (startingDate) => {
    if (startingDate) {
      // if before than today and before the end date
      if (startingDate <= new Date() && startingDate <= selectedEndDate) {
        // update state and UI
        setSelectedStartDate(startingDate);
        // set the min value for the other date to prevent errors
        document
          .getElementById('ToDate')
          .setAttribute('min', startingDate.toISOString().substr(0, 10));
      }
    }
  };

  const handleEndDateInput = (endingDate) => {
    if (endingDate) {
      // if before than today and after the start date
      if (endingDate <= new Date() && endingDate >= selectedStartDate) {
        endingDate.setMinutes(59);
        endingDate.setHours(23);
        // update state and UI
        setSelectedEndDate(endingDate);
        // set the max value for the other date to prevent errors
        document
          .getElementById('FromDate')
          .setAttribute('max', endingDate.toISOString().substr(0, 10));
      }
    }
  };

  $('[data-toggle="tooltip"]').tooltip();

  return (
    <div className='w-100 advanced-search p-3'>
      <div className='advanced-search__title'>
        <h2 className='h3 font-weight-bold ml-0'>
          <TabIndexBtn handleClick={handleCloseAdvSearch}>
            <CloseButton />
          </TabIndexBtn>
          Advanced Search for: {searchKeyword}
        </h2>
        {shouldSearchOnClose && (
          <TabIndexBtn
            handleClick={handleClearFilters}
            css='advanced-search__reset'
          >
            <FaUndo />
          </TabIndexBtn>
        )}
      </div>
      <form>
        {/* Search word and Document */}
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label>Search Keyword</label>
              <input
                className='form-control'
                type='text'
                name='Keyword'
                id='Keyword'
                value={searchKeyword}
                onChange={handleInput}
                onKeyDown={handleInput}
                placeholder='Keyword'
              />
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <label>Document</label>
              <select
                id='docs-list'
                className='form-control'
                onChange={(option) => handleDocSelected(option.target.value)}
              >
                {availableDocs &&
                  availableDocs.length > 0 &&
                  availableDocs.map((doc, index) => (
                    <option value={doc.id} key={index}>
                      {doc.title}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
        {/* Levels 1 and 2 */}
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label>{spStructure.LevelOne}</label>
              <select
                id='lvl1-list'
                className='form-control'
                onChange={(option) =>
                  handleSelectedLevelOne(option.target.value)
                }
              >
                {LevelOnesList &&
                  LevelOnesList.length > 0 &&
                  LevelOnesList.map((lvl1, index) => (
                    <option
                      value={lvl1}
                      key={index}
                      className={`${TranslateWorkaround(lvl1)}`}
                    >
                      {lvl1}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <label>{spStructure.LevelTwo}</label>
              <select
                id='lvl2-list'
                className='form-control'
                onChange={(option) =>
                  handleSelectedLevelTwo(option.target.value)
                }
              >
                {LevelTwosList &&
                  LevelTwosList.length > 0 &&
                  LevelTwosList.map((lvl2, index) => (
                    <option value={lvl2} key={index}>
                      {lvl2}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
        {/* Levels 3 and 4 */}
        {(spStructure.LevelThree || spStructure.LevelFour) && (
          <div className='row'>
            {spStructure.LevelThree && (
              <div className='col-md-6'>
                <div className='form-group'>
                  <label>{spStructure.LevelThree}</label>
                  <select
                    id='lvl3-list'
                    className='form-control'
                    onChange={(option) =>
                      handleSelectedLevelThree(option.target.value)
                    }
                  >
                    {LevelThreesList &&
                      LevelThreesList.length > 0 &&
                      LevelThreesList.map((lvl3, index) => (
                        <option value={lvl3} key={index}>
                          {lvl3}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            )}
            {spStructure.LevelFour && (
              <div className='col-md-6'>
                <div className='form-group'>
                  <label>{spStructure.LevelFour}</label>
                  <select
                    id='lvl4-list'
                    className='form-control'
                    onChange={(option) =>
                      handleSelectedLevelFour(option.target.value)
                    }
                  >
                    {LevelFoursList &&
                      LevelFoursList.length > 0 &&
                      LevelFoursList.map((lvl4, index) => (
                        <option value={lvl4} key={index}>
                          {lvl4}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
            )}
          </div>
        )}
        {/* Date and Search btn */}
        <div className='row'>
          <label className='col-md-12'>Published</label>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <div className='form-group'>
              <label>From</label>
              <input
                className='form-control'
                type='date'
                name='FromDate'
                id='FromDate'
                value={selectedStartDate.toISOString().substr(0, 10)}
                onChange={(date) =>
                  handleStartDateInput(date.target.valueAsDate)
                }
              />
            </div>
          </div>
          <div className='col-md-3'>
            <div className='form-group'>
              <label>To</label>
              <input
                className='form-control'
                type='date'
                name='ToDate'
                id='ToDate'
                value={selectedEndDate.toISOString().substr(0, 10)}
                onChange={(date) => handleEndDateInput(date.target.valueAsDate)}
              />
            </div>
          </div>
          <div className='col-md-6 substring-row'>
            {/* <div className='d-flex align-items-center justify-content-center'>
              <input
                type='checkbox'
                id='sub-search'
                className='mt-1'
                checked={substringSearch}
                onChange={() => setSubstringSearch(!substringSearch)}
              />
              <label
                htmlFor='sub-search'
                style={{ cursor: 'pointer' }}
                className='mb-0 ml-2'
              >
                Substring search
              </label>
              <FaInfoCircle
                className='ml-2'
                id='sub-search-icon'
                color={COLORS.DEFAULT}
                data-toggle='tooltip'
                data-original-title='Matches all occurences of the search term, regardless of placing or word break.'
              />
            </div> */}
            <button
              type='button'
              className='mr-3 py-1 px-3'
              onClick={handleAdvSearch}
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  documents: state.client.documents,
  spStructure: state.client.spStructure,
});

const mapDispatchToProps = { Search };

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AdvancedSearch);
